import {
    RENT_STATUS_TYPE_TIPPY_TEXT,
    RENT_STATUS_AVAILABLE,
    RENT_STATUS_RESERVED,
    RENT_STATUS_RENTED,
    RENT_STATUS_OUT_OF_SERVICE,
    RENT_STATUS_RETIRED,
    RENT_STATUS_SOLD,
    RENT_STATUS_TYPES,
    UPDATE_PERM
} from "../../../../common/util/util-consts";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import Tippy from "@tippyjs/react";
import React from "react";
import {checkPerm, classNames} from "../../../../common/util/util-helpers";
import Resources from "../../../../data/services/resources";
import Badge from "../../../../common/components/badge";
import {READ_PERM, TRUCK_STATUS_OUT_OF_SERVICE} from "../../../../util/util-constants";

export default function TrucksTableBadgeRental({item, itemType = 'Truck', onOutOfServiceClick, translate}) {
    const rentStatusID = item?.RentStatusID
    const isOutOfService = item.StatusID === TRUCK_STATUS_OUT_OF_SERVICE && checkPerm(Resources.TruckServices, READ_PERM);

    if (!item || !rentStatusID) {
        return null;
    }
    
    const canFollowLink = checkPerm(Resources.RentalInfo, UPDATE_PERM) && (rentStatusID === RENT_STATUS_RESERVED || rentStatusID === RENT_STATUS_RENTED)

    return (
        <Tippy
            disabled={!rentStatusID}
            content={<span>{`${itemType} ${translate(RENT_STATUS_TYPE_TIPPY_TEXT[rentStatusID])}`}</span>}
        >
            <div>
                <Badge
                    addClass={classNames(isOutOfService ? "cursor-pointer hover:bg-yellow-700" : undefined)}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canFollowLink) {
                            window.open(`${window.location.origin}/rentals/${item.RentalID}`, '_blank');
                        }

                        if (onOutOfServiceClick && isOutOfService) {
                            onOutOfServiceClick(item);
                        }
                    }}
                    type={getBadgeClass(rentStatusID)}>
                    <div className="flex">
                        {RENT_STATUS_TYPES[rentStatusID]}
                        {canFollowLink && (rentStatusID === RENT_STATUS_RESERVED || rentStatusID === RENT_STATUS_RENTED) && (
                            <ArrowTopRightOnSquareIcon
                                className={'w-5 h-5 ml-4'}
                            />
                        )}
                    </div>
                </Badge>
            </div>
        </Tippy>
    )
}

const getBadgeClass = (type) => {
    switch (type) {
        case RENT_STATUS_AVAILABLE:
            return "success"
        case RENT_STATUS_RESERVED:
        case RENT_STATUS_RENTED:
            return "primary"
        case RENT_STATUS_SOLD:
        case RENT_STATUS_RETIRED:
            return "danger"
        case RENT_STATUS_OUT_OF_SERVICE:
            return "warning"
        default:
            return "danger"
    }
}
